<template>
	<div v-if="item">
		<v-container
			v-if="item"
			class="container--narrow"
		>
			<v-card>
				<v-card-title v-text="item.title" />
				<v-divider />
				<v-card-text>
					<dl>
						<template v-if="item.startdate">
							<dt>Alkamispäivä</dt>
							<dd>{{ startDate }}</dd>
						</template>
						<template v-if="item.enddate">
							<dt>Päättymispäivä</dt>
							<dd>{{ endDate }}</dd>
						</template>
					</dl>
					<br>
					<SchemaToForm
						v-model="formData"
						:schema="config.forms.assignment"
						:disabled="formLoading"
						:debug="false"
						@valid="formValid = true"
						@invalid="formValid = false"
						@change="$store.commit('setConfirmNavigation', true)"
					/>
				</v-card-text>
				<v-divider />
				<v-card-actions v-if="(!item.enddate)">
					<v-subheader>
						Päätös käsitellään.
					</v-subheader>
					<v-spacer />
					<v-btn
						color="error"
						text
						:disabled="formLoading"
						@click="(confirmationDialog = true)"
					>
						Päätä tehtävä
					</v-btn>
				</v-card-actions>
			</v-card>
			<!-- confirmation dialog -->
			<v-dialog
				v-model="confirmationDialog"
			>
				<v-card>
					<v-card-title>
						Tehtävän päättäminen
					</v-card-title>
					<!-- <v-divider />
					<v-card-text>
						Lorem ipsum enim mollit ut amet reprehenderit eu fugiat aliqua nostrud anim consequat id laborum ad excepteur.
					</v-card-text> -->
					<v-divider />
					<v-card-actions>
						<v-spacer />
						<v-btn
							color="error"
							text
							:disabled="formLoading"
							@click="conclude"
						>
							Kyllä, lopetan tehtävässä
						</v-btn>
						<v-spacer />
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-container>
	</div>
</template>

<style lang="scss" scoped>
dl {
	display: grid;
	grid-template-columns: max-content auto;
	// grid-template-columns: 1fr auto;
	column-gap: 1rem;
	row-gap: 0.5rem;

	+ dl {
		margin-top: 1rem;
	}

	dt {
		grid-column-start: 1;

		font-weight: bold;
	}

	dd {
		grid-column-start: 2;
	}
}
</style>

<script>
import { mapState } from 'vuex'

export default {
	name: 'Memmbership',

	data: () => ({
		item: null,
		formData: {},
		formLoading: false,
		confirmationDialog: false,
	}),

	computed: {
		...mapState({
			config: state => state.config,
			items: state => state.user.assignment,
		}),

		startDate () {
			return (
				(this.item.startdate)
					? new Date(this.item.startdate).toLocaleDateString('fi-FI')
					: ''
			)
		},

		endDate () {
			return (
				(this.item.enddate)
					? new Date(this.item.enddate).toLocaleDateString('fi-FI')
					: ''
			)
		},
	},

	mounted () {
		this.loadItem()
	},

	methods: {
		loadItem () {
			this.item = this.items.find(item => {
				return item.name == this.$route.params.assignmentName
			})

			if (!this.item) {
				this.$router.replace({ name: 'error404' })
			}

			this.formData = JSON.parse(JSON.stringify(this.item))
		},

		conclude () {
			this.formLoading = true

			this.$api.Assignment.doRequest({
				method: 'POST',
				body: this.formData,
			}).on('done', (res) => {
				if (res.body.memberData) {
					this.formData = res.body.memberData
				}

				// Clear navigation confirm
				if (!res.body.error) {
					this.$nextTick(() => {
						this.$store.dispatch('clearConfirmNavigation')
					})
				}

				this.$router.push({
					name: 'assignments',
				})
			}).on('finish', () => {
				this.formLoading = false
			})
		},
	},
}
</script>
